import StopoverDurations from "app/pages/Stopover/StopoverDurations/StopoverDurations";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { useMemo } from "react";
import { updateBooking } from "app/pages/Booking/bookingActionCreators";

const StopoverDurationsContainer = props => {
	const stopoverDurations = useSelector(state => state.smartDP.stopoverDurations);
	const dispatch = useDispatch();
	const actions = useMemo(() => bindActionCreators({ updateBooking }, dispatch), [dispatch]);
	return <StopoverDurations {...props} stopoverDurations={stopoverDurations} {...actions} />;
};

StopoverDurationsContainer.propTypes = {};

export default StopoverDurationsContainer;
